import {JsonObject} from 'utilities/types'
import {CBaseRecord, IBaseRecord} from './_base'

export interface IGraphEntity extends IBaseRecord {
  id?: string
  name?: string
}

export class CGraphEntity<IType extends IGraphEntity>
  extends CBaseRecord<IType>
  implements IGraphEntity
{
  id
  name
  rawData: IGraphEntity
  entityType: string

  static external_id = 'entity_id'
  static record_name = 'entity'

  constructor(entityType: string, data: IGraphEntity & JsonObject) {
    super(data as IType & JsonObject)
    this.id = data.id // required so we can force id to be a string
    this.name = data.name ?? '<unknown>'
    this.rawData = data
    this.entityType = entityType
  }

  stringify() {
    return JSON.stringify(this.export())
  }

  // iProjectExternalResult(projectType?: CProjectType) {
  //   const now = DateTime.now().toISO() as string
  //   if (projectType) {
  //     return {
  //       created_at: now,
  //       updated_at: now,
  //       unique_id: this.id,
  //       external_unique_id: this.id,
  //       external_item: {data: this.rawData},
  //       step_links: projectType.steps.map((x) => x.iOldProjectTypeStep()),
  //     }
  //   } else {
  //     return {
  //       created_at: now,
  //       updated_at: now,
  //       unique_id: this.id,
  //       external_unique_id: this.id,
  //       external_item: {data: this.rawData},
  //     }
  //   }
  // }

  // toProjectExternalResult(projectType?: CProjectType) {
  //   return new ProjectExternalResult(this.iProjectExternalResult(projectType))
  // }

  // iProjectExternalResultStepLink(projectType: CProjectType, stepId: string) {
  //   const step = projectType.getStep(stepId ?? 'Considered')
  //   if (!step) {
  //     throw Error(
  //       `Step ID "${stepId}" not found in project type "${projectType.name}" ` +
  //         `(options were ${projectType.steps.map((x) => '"' + x.id + '"').join(', ')})`
  //     )
  //   }
  //   const project_external_result = this.iProjectExternalResult()
  //   return {
  //     created_at: project_external_result.created_at,
  //     updated_at: project_external_result.updated_at,
  //     unique_id: project_external_result.unique_id,
  //     is_award: this.entityType === 'Award',
  //     project_external_result,
  //     project_type_step: step.iOldProjectTypeStep(),
  //   }
  // }

  // toProjectExternalResultStepLink(projectType: CProjectType, stepId: string) {
  //   return new ProjectExternalResultStepLink(
  //     this.iProjectExternalResultStepLink(projectType, stepId)
  //   )
  // }
}
